import type { FleetCellPlanView } from '@/shared/api/__generated__'
import { StatusBadge } from '@/shared/ui/status-badge'
import { releaseSteps } from '../model/release'

interface ReleaseStepListProps {
  plans: FleetCellPlanView[] | null | undefined
}

/**
 * На каком шаге стоит слив каждой ячейки. Ответ бэка — единственное место, где
 * шаг виден: ни статус ячейки, ни паспорт юнита ожидания отчётов не показывают.
 */
export function ReleaseStepList({ plans }: ReleaseStepListProps) {
  const steps = releaseSteps(plans)
  if (steps.length === 0) {
    return <p className="text-body-sm text-muted">Ячеек под сливом нет.</p>
  }

  return (
    <ul className="flex flex-col gap-2">
      {steps.map((step) => (
        <li
          key={step.cellId}
          className="flex flex-col gap-1 rounded-control bg-raise px-4 py-3 text-body-sm"
        >
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span className="truncate font-mono text-caption">{step.cellId}</span>
            <StatusBadge tone={step.tone} label={step.label} />
          </div>
          <p className="text-muted">{step.detail}</p>
        </li>
      ))}
    </ul>
  )
}
